// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { NavigationInstruction, Next, PipelineStep, Redirect } from "aurelia-router";
import { ClientStatus, IClientService } from "services/Client/IClientService";

@autoinject
export class ClientRequiredStep implements PipelineStep {
    private clientService: IClientService;

    constructor(clientService: IClientService) {
        this.clientService = clientService;
    }

    public run(instruction: NavigationInstruction, next: Next): Promise<unknown> {
        if (instruction.config && instruction.config.settings && instruction.config.settings.clientAccess !== true) {
            // No client access required
            return next();
        }

        // Check client version status, ignore if the acquisition service is offline
        if (this.clientService.status !== ClientStatus.UnsupportedVersion) {
            return next();
        } else {
            // Create redirect to the update page

            // Add the current URL as a parameter, so we can return to it after login
            let uri = instruction.fragment;
            if (instruction.queryString) {
                uri += "?" + instruction.queryString;
            }

            const redirect = new Redirect("Client/update?from=" + encodeURIComponent(uri));
            return next.cancel(redirect);
        }
    }
}
